import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  Paper,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { makeStyles } from "@mui/styles";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
  },
  imageContainer: {
    position: 'relative',
    width: theme.spacing(20),
    height: theme.spacing(20),
    margin: '0 auto',
  },
  profileImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
  },
  uploadButton: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
  },
  form: {
    marginTop: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
  },
}));

const ProfileView = () => {
  const classes = useStyles();
  const [profile, setProfile] = useState({
    username: "",
    email: "",
    full_name: "",
    image: "",
  });
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    // Fetch user profile data from API
    api
      .get("auth/user/")
      .then((response) => {
        setProfile(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the profile data!", error);
      });
  }, []);

  const handleChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    
    // Create a preview URL for the selected image
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfile({
          ...profile,
          image: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("username", profile.username);
    formData.append("email", profile.email);
    formData.append("full_name", profile.full_name);
    if (imageFile) {
      formData.append("image", imageFile);
    }

    // Update user profile data via API using PATCH request
    api
      .patch("auth/user/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("Profile updated successfully!");
      })
      .catch((error) => {
        console.error("There was an error updating the profile!", error);
      });
  };

  return (
    <Container className={classes.container}>
      <Paper className={classes.paper} elevation={2}>
        <Typography variant="h4" gutterBottom>
          Profile
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Box className={classes.imageContainer}>
              <img
                src={profile.image || "/placeholder-profile.jpg"}
                alt="Profile"
                className={classes.profileImage}
              />
              <input
                accept="image/*"
                style={{ display: 'none' }}
                id="icon-button-file"
                type="file"
                onChange={handleImageChange}
              />
              <label htmlFor="icon-button-file">
                <IconButton
                  color="primary"
                  component="span"
                  className={classes.uploadButton}
                  size="small"
                >
                  <PhotoCamera /> Upload Image
                </IconButton>
              </label>
            </Box>
          </Grid>
          <Grid item xs={12} sm={8}>
            <form className={classes.form} onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                value={profile.username}
                onChange={handleChange}
                margin="normal"
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={profile.email}
                onChange={handleChange}
                margin="normal"
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Full Name"
                name="full_name"
                value={profile.full_name}
                onChange={handleChange}
                margin="normal"
                variant="outlined"
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                className={classes.submitButton}
              >
                Save Changes
              </Button>
            </form>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ProfileView;